<ng-template #conditionEditor let-condition>
  <div class="cfb-popover-line">
    <div class="select is-small cfb-popover-field">
      <select
        [ngModel]="condition.field"
        (ngModelChange)="setConditionField(condition, $event)"
        [disabled]="disabled"
      >
        <option [ngValue]="null">Choose a field…</option>
        <ng-container *ngFor="let bucket of fieldGroupsList; trackBy: trackByFieldGroup">
          <optgroup *ngIf="bucket.group" [label]="bucket.group">
            <option *ngFor="let field of bucket.fields; trackBy: trackByFieldId" [ngValue]="field.id">{{ field.label }}</option>
          </optgroup>
          <ng-container *ngIf="!bucket.group">
            <option *ngFor="let field of bucket.fields; trackBy: trackByFieldId" [ngValue]="field.id">{{ field.label }}</option>
          </ng-container>
        </ng-container>
      </select>
    </div>
  </div>

  <div class="cfb-popover-line" *ngIf="fieldOf(condition)">
    <div class="select is-small cfb-popover-op-select">
      <select
        [ngModel]="condition.op"
        (ngModelChange)="setConditionOp(condition, $event)"
        [disabled]="disabled"
      >
        <option *ngFor="let op of opsOf(condition); trackBy: trackByOpId" [ngValue]="op.id">{{ op.label }}</option>
      </select>
    </div>
  </div>

  <ng-container *ngIf="fieldOf(condition) as field">
    <div class="cfb-popover-line" *ngIf="field.type === 'flag'">
      <div class="select is-small">
        <select [(ngModel)]="condition.value" (ngModelChange)="onConditionValueChange()" [disabled]="disabled">
          <option [ngValue]="true">yes</option>
          <option [ngValue]="false">no</option>
        </select>
      </div>
    </div>

    <ng-container *ngIf="field.type !== 'flag' && argCount(condition) > 0">
      <div class="cfb-popover-line" *ngIf="isListOp(condition)">
        <input
          class="input is-small"
          type="text"
          placeholder="value, value, value"
          [(ngModel)]="condition.value"
          (ngModelChange)="onConditionValueChange()"
          [disabled]="disabled"
        >
      </div>

      <ng-container *ngIf="!isListOp(condition)">
        <div class="cfb-popover-line">
          <input
            *ngIf="field.type === 'number'"
            class="input is-small"
            type="number"
            [(ngModel)]="condition.value"
            (ngModelChange)="onConditionValueChange()"
            [disabled]="disabled"
          >
          <div *ngIf="field.type === 'select'" class="select is-small">
            <select [(ngModel)]="condition.value" (ngModelChange)="onConditionValueChange()" [disabled]="disabled">
              <option [ngValue]="null">Choose a value…</option>
              <option *ngFor="let opt of field.options" [ngValue]="opt.id">{{ opt.label || opt.id }}</option>
            </select>
          </div>
          <input
            *ngIf="field.type === 'text'"
            class="input is-small"
            type="text"
            [attr.list]="field.options?.length ? 'cfb-opts-' + field.id : null"
            [(ngModel)]="condition.value"
            (ngModelChange)="onConditionValueChange()"
            [disabled]="disabled"
          >
          <datalist *ngIf="field.type === 'text' && field.options?.length" [id]="'cfb-opts-' + field.id">
            <option *ngFor="let opt of field.options" [value]="opt.id"></option>
          </datalist>
        </div>
        <div class="cfb-popover-line" *ngIf="argCount(condition) === 2">
          <span class="cfb-popover-conj">and</span>
          <input
            class="input is-small"
            [type]="field.type === 'number' ? 'number' : 'text'"
            [(ngModel)]="condition.value2"
            (ngModelChange)="onConditionValueChange()"
            [disabled]="disabled"
          >
        </div>
      </ng-container>
    </ng-container>

    <p class="cfb-popover-hint" *ngIf="field.hint">{{ field.hint }}</p>
  </ng-container>
</ng-template>

<div class="cfb-backdrop" *ngIf="openConditionId" (click)="closeConditionEditor()"></div>

<div class="cfb-filter-row">
  <div class="cfb-filter-row-label">{{ rowLabel }}</div>

  <div class="cfb-filter-chip-wrap" *ngFor="let condition of conditions; trackBy: trackByConditionId">
    <span class="cfb-filter-chip" [class.is-set]="isConditionActive(condition)">
      <button
        type="button"
        class="cfb-chip-main"
        (click)="toggleConditionEditor(condition.id)"
        [disabled]="disabled"
      >
        <span class="cfb-chip-label">{{ conditionChipLabel(condition) }}</span>
        <span class="cfb-chip-value" *ngIf="conditionChipValue(condition)">{{ conditionChipValue(condition) }}</span>
      </button>
      <button
        type="button"
        class="cfb-chip-remove"
        (click)="removeCondition(condition)"
        [disabled]="disabled"
        aria-label="Remove filter"
      >&times;</button>
    </span>
    <div class="cfb-filter-popover" *ngIf="openConditionId === condition.id">
      <ng-container *ngTemplateOutlet="conditionEditor; context: { $implicit: condition }"></ng-container>
    </div>
  </div>

  <button type="button" class="button is-small" (click)="addCondition()" [disabled]="disabled">
    + Filter
  </button>

  <div class="cfb-join-toggle" *ngIf="conditions.length > 1">
    <button
      type="button"
      class="button is-small"
      [class.is-info]="joinMode !== 'OR'"
      (click)="setJoinMode('AND')"
      [disabled]="disabled"
    >All</button>
    <button
      type="button"
      class="button is-small"
      [class.is-info]="joinMode === 'OR'"
      (click)="setJoinMode('OR')"
      [disabled]="disabled"
    >Any</button>
  </div>

  <button type="button" class="button is-small is-text" (click)="toggleAdvanced()" *ngIf="conditions.length">
    {{ isAdvancedOpen ? 'Hide list' : 'Show as list' }}
  </button>
  <button type="button" class="button is-small is-text" (click)="clearConditions()" *ngIf="conditions.length" [disabled]="disabled">
    Clear
  </button>
</div>

<div class="cfb-advanced-filter" *ngIf="isAdvancedOpen">
  <div class="cfb-advanced-row" *ngFor="let condition of conditions; let i = index; trackBy: trackByConditionId">
    <span class="cfb-advanced-conj">{{ i === 0 ? 'Where' : (joinMode === 'OR' ? 'Or' : 'And') }}</span>
    <div class="cfb-advanced-editor">
      <ng-container *ngTemplateOutlet="conditionEditor; context: { $implicit: condition }"></ng-container>
    </div>
    <button type="button" class="button is-small is-danger" (click)="removeCondition(condition)" [disabled]="disabled">
      Remove
    </button>
  </div>
</div>

<div class="cfb-summary" *ngIf="summary">
  <div class="cfb-summary-counts">
    Showing <strong>{{ summary.shown }}</strong> of {{ summary.total }} {{ summaryNoun }}
  </div>
  <div class="cfb-summary-expression" *ngIf="summary.expression">
    Criteria: <code>{{ summary.expression }}</code>
  </div>
</div>
